import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import parse from "html-react-parser";

export class TakeawayMessages extends React.Component {
  render() {
    return (
      <div
        className={this.props.className}
        style={{
          background: this.props.caption ? "white" : null,
          borderRadius: this.props.caption ? "5px" : null,
          border: this.props.caption ? "1px solid #ccd8e1" : null,
          paddingTop: this.props.caption ? "8px" : null,
        }}
      >
        <h5
          style={{
            marginTop: this.props.description ? 16 : 0,
            marginLeft: this.props.caption ? "8px" : null,
          }}
        >
          {this.props.heading}
        </h5>
        <p style={{ marginTop: this.props.heading ? 16 : 0 }}>
          {this.props.description ? parse(this.props.description) : null}
        </p>
        <ul
          style={{
            marginTop: this.props.description ? 16 : 0,
            padding: this.props.caption ? "0 8px" : null,
          }}
        >
          {this.props.items.map((item, index) => {
            return (
              <li key={item + index}>
                <div className="img-container">
                  <img src={item.image} alt={parse(item.message)} />
                </div>
                <div className="tip">
                  <p>{parse(item.message)}</p>
                </div>
              </li>
            );
          })}
        </ul>
        {this.props.caption ? (
          <p className="caption">{this.props.caption}</p>
        ) : null}
      </div>
    );
  }
}

{
  /* <div className={this.props.className}>
  <h5 tabIndex={0}>{this.props.heading}</h5>
    {this.props.items.map((item, index)=>{
      return(
        <div style={{marginTop: '15px'}}>
          <TakeAwayWidget 
            image={item.image} 
            alt=""
            text={item.message}
            />
        </div>
      )
    })}
</div> */
}
TakeawayMessages.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  items: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TakeawayMessages.defaultProps = {
  className: "takeawayMessages",
};
